import { render, staticRenderFns } from "./MacroKpiContainer.vue?vue&type=template&id=45254d3e&scoped=true"
import script from "./MacroKpiContainer.vue?vue&type=script&lang=js"
export * from "./MacroKpiContainer.vue?vue&type=script&lang=js"
import style0 from "./MacroKpiContainer.vue?vue&type=style&index=0&id=45254d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45254d3e",
  null
  
)

export default component.exports